import { Button } from "@/components/ui/button";
import { PromoBar } from "@/components/PromoBar";
import { FreeBanner } from "@/components/FreeBanner";
import { isFreePeriod } from "@/lib/pricing";
import { startCheckout } from "@/lib/payments";
import { BadgeCheck, ShieldAlert, Loader2, Crown } from "lucide-react";

export function ProBanners({ user, verifying, verifyBtw, proPrice }) {
  if (user?.role !== "bedrijf") return null;
  const free = isFreePeriod();
  return (
    <>
      {free && <div className="mb-5"><FreeBanner /></div>}
      {!free && user?.pro_intro_eligible && (
        <div className="mb-5 rounded-md overflow-hidden">
          <PromoBar onClick={() => startCheckout({ kind: "pro" })} />
        </div>
      )}
      {user.btw_geverifieerd ? (
        <div data-testid="bedrijf-verified-banner" className="mb-5 flex items-center gap-2 bg-green-50 border border-green-200 text-green-800 rounded-md px-4 py-3 text-sm font-semibold">
          <BadgeCheck className="w-5 h-5 shrink-0" />
          Je BTW-nummer {user.btw_nummer} is geverifieerd. Professionals zien een "Geverifieerd"-badge bij jouw opdrachten.
        </div>
      ) : (
        <div data-testid="bedrijf-unverified-banner" className="mb-5 flex flex-wrap items-center gap-3 bg-amber-50 border border-amber-200 text-amber-800 rounded-md px-4 py-3 text-sm">
          <ShieldAlert className="w-5 h-5 shrink-0" />
          <span className="font-semibold flex-1 min-w-[200px]">Je BTW-nummer is nog niet geverifieerd. Geverifieerde bedrijven krijgen een badge en staan bovenaan bij professionals.</span>
          <Button data-testid="verifieer-btw-btn" onClick={verifyBtw} disabled={verifying}
            className="bg-amber-600 hover:bg-amber-700 text-white rounded-sm font-bold shrink-0">
            {verifying ? <Loader2 className="w-4 h-4 animate-spin" /> : "Verifieer nu"}
          </Button>
        </div>
      )}
      {!free && (user.pro ? (() => {
        const daysLeft = Math.ceil((new Date(user.pro_until) - new Date()) / 86400000);
        if (daysLeft <= 7) {
          return (
            <div data-testid="bedrijf-pro-expiring-banner" className="mb-5 flex flex-wrap items-center gap-3 bg-amber-50 border border-amber-300 text-amber-900 rounded-md px-4 py-3 text-sm">
              <Crown className="w-5 h-5 shrink-0 text-amber-600" />
              <span className="font-semibold flex-1 min-w-[200px]">
                Je Pro-toegang verloopt {daysLeft <= 0 ? "vandaag" : daysLeft === 1 ? "morgen" : `over ${daysLeft} dagen`} ({new Date(user.pro_until).toLocaleDateString("nl-NL")}). Verleng nu om opdrachten te kunnen blijven plaatsen.
              </span>
              <Button data-testid="bedrijf-renew-btn" onClick={() => startCheckout({ kind: "pro" })}
                className="bg-amber-600 hover:bg-amber-700 text-white rounded-sm font-bold shrink-0">
                Verleng · {proPrice}
              </Button>
            </div>
          );
        }
        return (
          <div data-testid="bedrijf-pro-banner" className="mb-5 flex items-center gap-2 bg-orange-50 border border-orange-200 text-orange-800 rounded-md px-4 py-3 text-sm font-semibold">
            <Crown className="w-5 h-5 shrink-0" />
            Pro actief tot {new Date(user.pro_until).toLocaleDateString("nl-NL")}. Je kunt opdrachten plaatsen en aanvragen sturen.
          </div>
        );
      })() : (
        <div data-testid="bedrijf-upgrade-banner" className="mb-5 flex flex-wrap items-center gap-3 bg-slate-900 text-white rounded-md px-4 py-3 text-sm">
          <Crown className="w-5 h-5 shrink-0 text-orange-400" />
          <span className="font-semibold flex-1 min-w-[200px]">Je Pro-toegang is verlopen. Word Pro om opdrachten te plaatsen en professionals te benaderen. {user?.pro_intro_eligible && "Nu je eerste kwartaal voor maar €1!"}</span>
          <Button data-testid="bedrijf-upgrade-btn" onClick={() => startCheckout({ kind: "pro" })}
            className="bg-orange-500 hover:bg-orange-600 text-white rounded-sm font-bold shrink-0">
            Word Pro · {proPrice}
          </Button>
        </div>
      ))}
    </>
  );
}
